import { COLORS, RADIUS, fontFamilyFor } from "../../theme";

const headingFont = (isArabic) =>
  isArabic ? fontFamilyFor("ar") : "'Playfair Display', serif";

export const Style = {
  page: {
    background: COLORS.dark,
    color: "#fff",
    minHeight: "60vh",
  },
  hero: {
    padding: { xs: "3rem 1.5rem 2rem", md: "6rem 3rem 3rem" },
    textAlign: "center",
  },
  heroTitle: (isArabic) => ({
    fontFamily: headingFont(isArabic),
    fontSize: { xs: "2.6rem", md: "4rem" },
    fontWeight: 700,
    mb: "1rem",
    background: `linear-gradient(135deg, #fff 0%, ${COLORS.peach} 100%)`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  }),
  subtitle: {
    fontSize: { xs: "1.05rem", md: "1.3rem" },
    color: "rgba(255,255,255,0.7)",
    maxWidth: "700px",
    margin: "0 auto",
  },
  loaderWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "6rem 1.5rem",
  },
  errorWrap: {
    textAlign: "center",
    padding: "4rem 1.5rem 6rem",
  },
  errorText: {
    color: "rgba(255,255,255,0.7)",
    fontSize: "1.1rem",
    mb: "1.5rem",
  },
  backButton: {
    display: "inline-block",
    padding: "0.9rem 2.2rem",
    background: COLORS.peach,
    color: COLORS.dark,
    borderRadius: RADIUS.pill,
    fontWeight: 700,
    fontSize: "1rem",
    cursor: "pointer",
    border: "none",
    "&:hover": { background: COLORS.gold },
  },
  // Wraps the CMS-authored HTML (h1/h2/p/ul/li/hr/a) with the new design's
  // legal-page typography. The CMS content repeats the page title as an
  // <h1>, so it's hidden here since the hero above already shows it.
  prose: (isArabic) => ({
    maxWidth: "820px",
    margin: "0 auto",
    padding: { xs: "1rem 1.5rem 4rem", md: "1rem 3rem 6rem" },
    lineHeight: 1.8,
    color: "rgba(255,255,255,0.72)",
    fontFamily: fontFamilyFor(isArabic ? "ar" : "en"),
    direction: isArabic ? "rtl" : "ltr",
    "& > h1:first-of-type": { display: "none" },
    "& h1": {
      fontFamily: headingFont(isArabic),
      fontSize: "2rem",
      color: COLORS.peach,
      margin: "0 0 1rem",
    },
    "& h2": {
      fontFamily: headingFont(isArabic),
      color: COLORS.peach,
      fontSize: "1.4rem",
      margin: "2.5rem 0 0.8rem",
    },
    "& p": {
      margin: "0 0 1.2rem",
    },
    "& ul, & ol": {
      margin: "0 0 1.2rem",
      paddingInlineStart: "1.5rem",
    },
    "& li": {
      marginBottom: "0.5rem",
    },
    "& hr": {
      border: "none",
      borderTop: "1px solid rgba(255,255,255,0.1)",
      margin: "2.5rem 0",
    },
    "& a": {
      color: COLORS.peach,
      fontWeight: 600,
      textDecoration: "none",
    },
    "& a:hover": {
      textDecoration: "underline",
    },
  }),
};
